import React from 'react'

const MakeGamePack = () => {

  const createGamePack = async () => {
    console.log('ゲームパックを作成します。');
    const gameDataFile = document.querySelector('input[type="file"]')?.files?.[0];
    console.log(gameDataFile);
  
    if (!gameDataFile) {
      alert('ゲームデータファイルを選択してください。');
      return;
    }
  
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const gameData = JSON.parse(event.target.result);
        const gamePackData = {
          info: {
            name: gameData.info.name,
            detail: gameData.info.detail,
            public: false,
            auto: gameData.info.auto,
            startTime: gameData.info.startTime,
            prepareLimitTime: gameData.info.prepareLimitTime,
            endTime: gameData.info.endTime,
            mapCenter: gameData.info.mapCenter,
            updateDate: new Date().toISOString(),
            location: gameData.info.location,
            gameMode: gameData.info.gameMode,
            package: true,
            opened: false
          },
          missions: gameData.missions,
          specialItems: gameData.specialItems ?? null,
          members: [],
          teams: [],
          notify: {
            discordWebhook: null,
            option: [true, true]
          }
        };
  
        console.log(gamePackData);
        downloadGamePack(gamePackData);
      } catch (error) {
        console.error(error);
        alert('ゲームデータファイルの読み込みに失敗しました。');
      }
    };
  
    reader.readAsText(gameDataFile); // これが必要！
  };
  

  const downloadGamePack = (gamePackData) => {
    // JSONデータを文字列に変換
    const jsonString = JSON.stringify(gamePackData, null, 2);

    // Blobオブジェクトを作成
    const blob = new Blob([jsonString], { type: 'application/json' });

    // ダウンロード用のURLを作成
    const url = URL.createObjectURL(blob);

    // a要素を作成してダウンロードをトリガー
    const a = document.createElement('a');
    a.href = url;
    a.download = 'game_pack.json';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  return (
    <div className='max-w-3xl mx-auto my-4 px-3'>
      <h1 className='text-center text-2xl mb-6 text-purple-900'>ゲームパックを作成</h1>

      {/* ゲームデータファイルをインポート */}
      <div className='bg-white shadow-sm rounded-lg p-4 mb-6 max-w-2xl mx-auto'>
        <h2 className='text-gray-800 font-semibold text-lg mb-2'>ゲームデータをインポート</h2>
        <p className='text-gray-600 text-base'>ゲームデータのJSONファイルを選択してください。</p>
        <input type="file" accept=".json" className='border border-gray-300 rounded-lg p-2 w-full mt-2' />

        <div className='flex justify-end'>
          <button onClick={() => createGamePack()} className='bg-purple-500 hover:bg-purple-600 text-white rounded-lg px-4 py-2 mt-4'>ゲームパックを作成</button>
        </div>
      </div>
    </div>
  )
}

export default MakeGamePack